<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--带折叠的搜索start-->
			<div>
				<el-form size="mini" style="display: flex;flex-wrap: wrap;padding-left: 8px;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="150px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;">

						<el-form-item  v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>

						<el-form-item label="手机号" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="请输入手机号" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="ETM姓名" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_name" placeholder="请输入ETM姓名" clearable size="mini" />
						</el-form-item>
						
						<el-form-item v-if="!isMobile" label="ETM昵称" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_nickname" placeholder="请输入ETM昵称" clearable size="mini" />
						</el-form-item>
						
				
					
						
					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">
						
						<el-form-item  v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="手机号" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="请输入手机号" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="ETM姓名" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_name" placeholder="请输入ETM姓名" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="ETM昵称" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_nickname" placeholder="请输入ETM昵称" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="微信名" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.nickname" placeholder="请输入微信名称" clearable size="mini" />
						</el-form-item>
						
						<el-form-item label="日期" style="width: 40%;display: flex;">
							<div slot="label" style="width: 110px;text-align: right;">日期</div>
							<el-date-picker style="" v-model="searchForm.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
						</el-form-item>
						
						
						<el-form-item  v-if="role=='hq_admin'" label="ETM会员" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.is_vip" clearable placeholder="请选择">
								<el-option  label="是" :value="1" />
								<el-option  label="否" :value="0" />
							</el-select>
						</el-form-item>
						
						<el-form-item  v-if="role=='hq_admin'" label="家庭组会员" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.group_vip" clearable placeholder="请选择">
								<el-option  label="是" :value="1" />
							</el-select>
						</el-form-item>
						
						<el-form-item  v-if="role=='hq_admin'" label="城代用户" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.is_admin" clearable placeholder="请选择">
								<el-option  label="是" :value="1" />
								<el-option  label="否" :value="0" />
							</el-select>
						</el-form-item>
						
						<el-form-item  v-if="role=='hq_admin'" label="供货用户" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.is_supply" clearable placeholder="请选择">
								<el-option  label="是" :value="1" />
								<el-option  label="否" :value="0" />
							</el-select>
						</el-form-item>
						
						
						<el-form-item  label="注册类型" style="width: 23%;display: flex;">
							<!-- 0: 未知, 1: 微信搜索, 2: 微信扫码, 3: 公众号, 4: 视频号, 5: 链接分享 -->
							<el-select v-model="searchForm.register_type" clearable placeholder="请选择">
								<el-option  label="未知" :value="0" />
								<el-option  label="微信搜索" :value="1" />
								<el-option  label="微信扫码" :value="2" />
								<el-option  label="公众号" :value="3" />
								<el-option  label="视频号" :value="4" />
								<el-option  label="链接分享" :value="5" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="分享用户手机号" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.share_user_mobile" placeholder="请输入手机号" clearable size="mini" />
						</el-form-item>
						
						
						
					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div>
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start -->
			<div v-if="false" style="margin-top: 10px;display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;">
				
				<div style="margin-right: 20px;margin-left: 35px;">
					<el-button @click="showAddGoodsPop" type="primary" round icon="el-icon-plus" size="mini">添加商品</el-button>
				</div>
				
				<div class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					<div class="sortItem dis" @click="sort(0,'updated_at')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						时间
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'sales')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						销量
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					
					<div class="sortItem dis" @click="sort(2,'price')" :style="{color: sortIndex==2?'#fff':'#777','font-weight': sortIndex==2?'bold':'400','background-color': sortIndex==2?'#9E819F':''}">
						售价
						<img v-if="sortIndex==2&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;"/>
						<img v-if="sortIndex==2&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

				</div>

				
			</div>
			<!-- 只允许单选的排序end -->
		</div>





		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;margin-left: 20px;">
						<div class="avatar">

							<!--用户图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.avatar" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.avatar)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--用户图片end-->

							<div style="width: 180px;">

								<!--头像右侧一个列表项start-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								<!--头像右侧一个列表项end-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">微信名：</span>
									<el-tooltip :content="row.nickname" placement="right">
										<div class="dian dianL">{{row.nickname}}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">性别：</span>
									<el-tooltip :content="row.sex?(row.sex==1?'男':'女') :'未知' " placement="right">
										<div class="dian dianL">{{row.sex?(row.sex==1?'男':'女') :'未知' }}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">手机号：</span>
									<el-tooltip :content="row.mobile+''" placement="right">
										<div class="dian dianL">{{row.mobile}}</div>
									</el-tooltip>
								</div>

	

							</div>
						</div>

						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">

							
							<li>
								<el-tooltip :content="row.etm_vip==1?'是':'否'" placement="right">
							
									<div class="content dis">
										{{row.etm_vip==1?'是':'否'}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">ETM会员</div>
							</li>
							
							<li>
								<div class="content dis">
									<el-tooltip :content="row.etm_nickname?row.etm_nickname:'无'" placement="right">
										<div class="dian">{{row.etm_nickname?row.etm_nickname:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">ETM昵称</div>
							</li>
							
							<li>
								<div class="content dis">
									<el-tooltip :content="row.etm_name?row.etm_name:'无'" placement="right">
										<div class="dian">{{row.etm_name?row.etm_name:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">ETM姓名</div>
							</li>
							
							<li>
								<div class="content dis">
									<el-tooltip :content="row.coursereturn_count+''" placement="right">
										<div class="dian">{{row.coursereturn_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">剩余返课次数</div>
							</li>
							
							
							
							
							<li  v-if="role=='hq_admin'">
								<div class="content dis">
									<el-tooltip :content="row.is_admin==1?'是':'否'" placement="right">
										<div class="dian">{{row.is_admin==1?'是':'否'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">城代用户</div>
							</li>
							
							<li  v-if="role=='hq_admin'">
								<div class="content dis">
									<el-tooltip :content="row.is_supply==1?'是':'否'" placement="right">
										<div class="dian">{{row.is_supply==1?'是':'否'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">供货用户</div>
							</li>
							
							
				

							
							

							<!-- 一个方块列表项start-->
							<li >
								<div class="content">
									<img v-if="row.store" :src="row.store.image" style="width:50px;cursor: pointer;" @click="handlePreView(row.store.image)">
									<div v-else>无</div>
								</div>
								<div class="titleFont dian">门店图片</div>
							</li>
							<!-- 一个方块列表项end-->

							<li >
								<div class="content" >
									<el-tooltip v-if="row.store" :content="row.store.name" placement="right" >
										<div class="dian" >{{row.store.name}}</div>
									</el-tooltip>
									<div v-else style="text-align: center;">无</div>
								</div>
								<div class="titleFont">门店名称</div>
							</li>



							<li>
								<div class="content">
									<!-- 0: 未知, 1: 微信搜索, 2: 微信扫码, 3: 公众号, 4: 视频号, 5: 链接分享 -->
									<div v-if="row.register_type==0" class="dian">未知</div>
									<div v-if="row.register_type==1" class="dian">微信搜索</div>
									<div v-if="row.register_type==2" class="dian">微信扫码</div>
									<div v-if="row.register_type==3" class="dian">公众号</div>
									<div v-if="row.register_type==4" class="dian">视频号</div>
									<div v-if="row.register_type==5" class="dian">链接分享</div>
								</div>
								<div class="titleFont dian">注册类型</div>
							</li>
							
							<!-- <li >
								<div class="content">
									<img v-if="row.share_user" :src="row.share_user.avatar" style="width:50px;cursor: pointer;" @click="handlePreView(row.share_user.avatar)">
									<div v-else>无</div>
								</div>
								<div class="titleFont dian">分享用户头像</div>
							</li> -->
							
							<li >
								<div class="content">
									<el-tooltip v-if="row.share_user" :content="row.share_user.nickname" placement="right" >
										<div class="dian" >{{row.share_user.nickname}}</div>
									</el-tooltip>
									<div v-else style="text-align: center;">无</div>
								</div>
								<div class="titleFont dian">分享用户昵称</div>
							</li>
							
							
							


							<li>
								<el-tooltip :content="row.created_at+''" placement="right">

									<div class="content dis">
										{{row.created_at | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">创建时间</div>
							</li>

						</ul>


						<div  style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item v-if="role=='hq_admin'&&row.is_admin==0">
										<el-button type="success" size="mini" round @click="setChengDai(row,1)">设为城代用户
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-if="role=='hq_admin'&&row.is_admin==1">
										<el-button type="danger" size="mini" round @click="setChengDai(row,0)">取消城代用户
										</el-button>
									</el-dropdown-item>
									
									
									<el-dropdown-item v-if="role=='hq_admin'&&row.is_supply==0">
										<el-button type="success" size="mini" round @click="setGongHuo(row,2)">设为供货用户
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-if="role=='hq_admin'&&row.is_supply==1">
										<el-button type="danger" size="mini" round @click="setGongHuo(row,0)">取消供货用户
										</el-button>
									</el-dropdown-item>
									
									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showFanKeList(row)">查看返课记录
										</el-button>
									</el-dropdown-item>
									
									<el-dropdown-item v-if="row.coursereturn_count>0">
										<el-button type="success" size="mini" round @click="addFanKe(row)">添加返课记录
										</el-button>
									</el-dropdown-item>
									
									




								</el-dropdown-menu>
							</el-dropdown>

						</div>


						

					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->
		
		
		<!-- 添加返课记录弹窗start-->
		<el-dialog :close-on-click-modal="false" width="550px" custom-class="m-dialog" title="添加返课记录" center :visible.sync="isShowAddFanKePop">
			<div style="padding-top: 20px;" class="dis">
			
				<el-form label-width="100px" size="small" ref="form1" :rules="form1Rules" :model="form1">
			
					<el-form-item label="课程名称" prop="course_name">
						 <el-autocomplete
							  style="width: 100%;"
						      v-model="form1.course_name"
						      :fetch-suggestions="keChengNameQuery"
						      placeholder="请输入课程名称"
						    ></el-autocomplete>
					</el-form-item>
					

					<el-form-item label="课程数量" prop="course_count">
						<el-input v-model="form1.course_count"  placeholder="请输入课程数量" type="number"></el-input>
					</el-form-item>
					
					<el-form-item label="授课时间" prop="schooltime">
						<el-date-picker
						      v-model="form1.schooltime"
						      type="datetime"
						      placeholder="请选择授课时间">
						    </el-date-picker>
					</el-form-item>
					
			
			
			
				</el-form>
			
			</div>
			<div class="dis" style="justify-content: flex-end;">
				<el-button round  @click="submitAddFanXian('form1')" type="primary" size="small">确认</el-button>
			</div>
		</el-dialog>
		<!-- 添加返课记录弹窗end -->
		
		
		<!-- 返课记录弹窗start-->
		<el-dialog width="1050px" :close-on-click-modal="false"  custom-class="m-dialog" title="返课记录" center :visible.sync="isShowFanKeListPop">
			<div  class="dis">
			
			<el-table
					:row-style="{ 'text-align': 'center'}"
			      :data="fanKeList"
			      style="width: 100%">
			      <el-table-column
				  align="center"
			        prop="id"
			        label="id"
			        >
			      </el-table-column>
			      <el-table-column
					align="center"
			        prop="course_name"
			        label="课程名称"
			        >
			      </el-table-column>
			      <el-table-column
				  align="center"
			        prop="course_count"
			        label="课程数量">
			      </el-table-column>
				  <el-table-column
				  align="center"
				    prop="schooltime"
				    label="	授课时间">
				  </el-table-column>
				  <el-table-column
				  align="center"
				    prop="created_at"
				    label="	创建时间">
				  </el-table-column>
				  
			    </el-table>
				
			
			</div>
			
		</el-dialog>
		<!-- 返课记录弹窗end -->
		


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
		
		
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';

	export default {
		name: '',
		components: {
		
		},
		data() {
			return {
				
				fanKeList:[],
				isShowFanKeListPop:false,
				fhRestaurants: [{
						value: "水疗"
					},
					{
						value: "水训"
					}
				],
				form1: {
					course_name: '', 
					course_count: "",
					schooltime:''
				},
				form1Rules: {
					course_count: [{
						required: true,
						message: '请输入课程数量',
						trigger: 'blur'
					}],
					course_name: [{
						required: true,
						message: '请输入课程名称',
						trigger: 'change'
					}],
					schooltime: [{
						required: true,
						message: '请选择授课时间',
						trigger: 'blur'
					}],
					
				},
				isShowAddFanKePop:false,//是否显示返课弹窗
				currentRowByFanKe:"",
				
				role:'',
				mobileWidth:window.mobileWidth+50,
				isMobile:window.isMobile,
				rowGoods_id: '', //列表项的商品id

				isShowCollapse: false, //是否展开搜索项
				searchForm: {
					

				},

				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址


				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换
				storeList:[],//门店列表

				typeOptions: [{
					value: 'zhinan1',
					label: '指南1',
					children: [{
						value: 'daohang1',
						label: '导航1'
					}]
				}, {
					value: 'zhinan2',
					label: '指南2',
					children: [{
						value: 'daohang2-1',
						label: '导航2-1'
					}, {
						value: 'daohang2-2',
						label: '222导航2-2'
					}]
				}], //分类列表


			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			this.getTableHeight();
		},
		mounted() {
			this.role = localStorage.getItem("role")?localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g,''):'';//获取当前用户角色
			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};

			if(this.role=="hq_admin"){
				this.getStore();
			}
			
			this.initData();
		},

		methods: {
			
			//添加返课提交
			async submitAddFanXian(formName){
				this.$refs[formName].validate(async (valid) => {
				
					if (valid) { //校验成功
						this.loading = true;
						let schooltime = (this.form1.schooltime.getTime())/1000;
						
						let res = await ajax('/user/coursereturn/add', 'POST', {
							user_id:this.currentRowByFanKe.id,
							course_name:this.form1.course_name,
							course_count:this.form1.course_count,
							schooltime
						});
						this.loading = false;
						
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.$refs[formName].resetFields();
						this.form1 =  {
							course_name: '', 
							course_count: "",
							schooltime:''
						};
						
						this.initData();
						this.isShowAddFanKePop = false;
					
					}else { //校验失败
							console.log('校验失败')
							this.$message.error('请完善信息');
							return false;
					}
					
					
				});
					
			},
			
			keChengNameQuery(queryString, cb) {
				var restaurants = this.fhRestaurants;
				var results = queryString ? restaurants.filter(this.fhCreateFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			
			fhCreateFilter(queryString) {
				return (restaurant) => {
					return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			
			//添加用户返课记录
			addFanKe(row){
				this.currentRowByFanKe = row;
				this.form1.course_name = ''; 
				this.form1.course_count = ''; 
				this.form1.schooltime = ''; 
				
				this.isShowAddFanKePop = true;
				
			},
			//查看用户返课记录
			async showFanKeList(row){
				this.fanKeList = [];
				this.currentRowByFanKe = row;
				this.loading = true;
				let res = await ajax('/user/coursereturn/record', 'GET',{user_id:row.id});
				
				this.fanKeList = res.data.data.record;
				
				this.loading = false;
				this.isShowFanKeListPop = true;
			},
			
			//获取门店列表
			async getStore(){
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},
			
			//设置城代用户,is_admin为0是普通用户，1为设为城代
			async setChengDai(row,is_admin){
				this.loading = true
				let ress = await ajax('/hq/user/edit', 'PUT',{user_id:row.id,type:is_admin});
				this.loading = false;
				this.$message({
				          message: '设置成功!',
				          type: 'success'
				 });
				this.initData();
			},
			
			//设置供货用户 is_supply为0是普通用户，2为设为供货
			async setGongHuo(row,is_supply){
				this.loading = true
				let ress = await ajax('/hq/user/edit', 'PUT',{user_id:row.id,type:is_supply});
				this.loading = false;
				this.$message({
				          message: '设置成功!',
				          type: 'success'
				 });
				this.initData();
			},
			//初始化表格数据
			async initData() {
				this.loading = true
				var searchForm = this.searchForm
				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.is_vip === "") { //select未选中为空字符串
					searchForm.is_vip = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.group_vip === "") { //select未选中为空字符串
					searchForm.group_vip = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.is_admin === "") { //select未选中为空字符串
					searchForm.is_admin = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.is_supply === "") { //select未选中为空字符串
					searchForm.is_supply = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.register_type === "") { //select未选中为空字符串
					searchForm.register_type = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.share_user_mobile === "") { //select未选中为空字符串
					searchForm.share_user_mobile = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.mobile === "") { //select未选中为空字符串
					searchForm.mobile = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.nickname === "") { //select未选中为空字符串
					searchForm.nickname = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.etm_name === "") { //select未选中为空字符串
					searchForm.etm_name = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.etm_nickname === "") { //select未选中为空字符串
					searchForm.etm_nickname = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				
				if (searchForm.date === "" ||searchForm.date ===null) { //select未选中为空字符串
					searchForm.date = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.date && searchForm.date.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.date;
					if (arr[0].getTime) {
						searchForm.date = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.date = arr;
					}

				}
				
				let param = {
				
					...searchForm,
					
					count: this.pageSize,
					page: this.pageNumber
				}
				
				if(searchForm.sort){
					param.sort =searchForm.sort;//排序的属性名
					param.sort_rule = searchForm.sort_rule;//排序的方式
				}
				
				let url = '';
				if(this.role=="hq_admin"){
					url='/hq/user/list';
				}
				
				if(this.role=="store_admin"||this.role=='store_sa'){
					url='/store/user/list';
				}
				
				let ress = await ajax(url, 'POST',param);
				this.loading = false;
				let res = ress.data.data;

				this.total = res.total;
				this.tableData = res.user;
			},


			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 200; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				this.tableData=[];//这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = '';//排序的属性名
					this.searchForm.sort_rule = '';//排序的方式
					//获取默认排序的表格数据
					
					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName;//排序的属性名
						this.searchForm.sort_rule = 'desc';//排序的方式
						//获取表格列表
						
						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName;//排序的属性名
						this.searchForm.sort_rule = 'asc';//排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName;//排序的属性名
				this.searchForm.sort_rule = 'desc';//排序的方式
				//获取表格列表
	
				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},




			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm={};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {
		
		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
